export default {"src":"/_next/static/media/Share.8cf9e036.svg","height":24,"width":24};